import React from 'react';
import Loadable from 'react-loadable';

import './WeaVersion.less';

const loadable = (loader, loading = () => null) => Loadable({ loader, loading });
const WeaVersion = loadable(() => import('./WeaVersion'));

class Index extends React.Component {
  constructor(props) {
    super(props);
    const { location = {}, visible = false } = props;
    const { query = {} } = location;
    const { display = '' } = query;
    this.state = { display, visible };
  }

  render() {
    const { display, visible } = this.state;
    return display == 'page' || visible ? <WeaVersion ecId={`${this && this.props && this.props.ecId || ''}_WeaVersion@865sih`} {...this.props} display={display} visible={visible} onShow={this.onShow} /> : null;
  }

  onShow = (visible = true) => {
    this.setState({ visible });
  };

  onHide = () => {
    this.setState({ visible: false });
  };
}

export default Index;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/components/wea-version/index.js